export const SOLVE_ACTION_TYPE = 'solve';

export const FIRST_CORRECT_SCORE = 100;
export const FIREST_INCORRECT_SCORE = 50;
export const REVIEW_SCORE = 1;

export const FOCUS_TIME_INTERVAL_SECONDS = 180; // 3分ごと
export const FOCUS_TIME_SCORE_PER_INTERVAL = 10; // 間隔ごとに加算されるポイント
